export default "__VITE_ASSET__CEtZtbH3__"